import { createReducer } from '@reduxjs/toolkit';

import {
  setJobMode,
  setJobType,
  setJobCity,
  setOrgSlug,
  setJobSlug,
  setJobTitle,
  initialState,
  setJobStatus,
  setJobCountryId,
  setJobCountryName,
  setAllJobProperties,
  addCompareCandidate,
  removeCompareCandidate,
  clearCompareCandidates,
  setCompareCandidateIds,
} from '../Actions/jobEditorActions';

import type { JobEditorState } from '../Actions/jobEditorActions';

const jobEditorReducer = createReducer<JobEditorState>(initialState, (builder) => {
  builder
    .addCase(setJobTitle, (state, action) => {
      state.jobTitle = action.payload;
    })
    .addCase(setJobCountryName, (state, action) => {
      state.jobCountryName = action.payload;
    })
    .addCase(setJobCountryId, (state, action) => {
      state.jobCountryId = action.payload;
    })
    .addCase(setJobMode, (state, action) => {
      state.jobMode = action.payload;
    })
    .addCase(setJobType, (state, action) => {
      state.jobType = action.payload;
    })
    .addCase(setJobCity, (state, action) => {
      state.jobCity = action.payload;
    })
    .addCase(setJobStatus, (state, action) => {
      state.jobStatus = action.payload;
    })
    .addCase(setJobSlug, (state, action) => {
      state.jobSlug = action.payload;
    })
    .addCase(setOrgSlug, (state, action) => {
      state.orgSlug = action.payload;
    })
    .addCase(addCompareCandidate, (state, action) => {
      if (!state.compareCandidateIds.includes(action.payload)) {
        state.compareCandidateIds.push(action.payload);
      }
    })
    .addCase(removeCompareCandidate, (state, action) => {
      state.compareCandidateIds = state.compareCandidateIds.filter((id) => id !== action.payload);
    })
    .addCase(clearCompareCandidates, (state) => {
      state.compareCandidateIds = [];
    })
    .addCase(setCompareCandidateIds, (state, action) => {
      state.compareCandidateIds = action.payload;
    })
    .addCase(setAllJobProperties, (state, action) => ({ ...state, ...action.payload }));
});

export default jobEditorReducer;
